import { BaseLink, SocialLink } from './interfaces';

export const REGIO_FOOTER_LINKS_DEFAULT: BaseLink[] = [
  { label: 'Impressum', url: 'https://www.enercity.de/impressum' },
  {
    label: 'Datenschutz',
    url: 'https://www.enercity.de/datenschutz',
  },
  {
    label: 'Seitenübersicht',
    url: 'https://www.enercity.de/seitenuebersicht',
  },
];

export const REGIO_FOOTER_SOCIAL_LINKS_DEFAULT: SocialLink[] = [
  {
    iconVariant: 'action/facebook',
    url: 'https://www.facebook.com/enercity/',
    title: 'enercity auf Facebook folgen',
  },
  {
    iconVariant: 'action/instagram',
    url: 'https://www.instagram.com/enercity_ag',
    title: 'enercity auf Instagram folgen',
  },
  {
    iconVariant: 'action/xing',
    url: 'https://www.xing.com/pages/enercity',
    title: 'enercity auf Xing folgen',
  },
  {
    iconVariant: 'action/kununu',
    url: 'https://www.kununu.com/de/enercity',
    title: 'enercity auf kununu folgen',
  },
  {
    iconVariant: 'action/linkedin',
    url: 'https://de.linkedin.com/company/enercity-ag',
    title: 'enercity auf LinkedIn folgen',
  },
];
